import {
  CREATEDEPARTMENT_FAIL,
  CREATEDEPARTMENT_SUCCESS,
} from "../actionTypes";

const initialState = {
  user: null,
};

const createDepartmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATEDEPARTMENT_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
      };
    case CREATEDEPARTMENT_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      break;
  }

  return state;
};

export default createDepartmentReducer;
